import { axios } from '../../services/axios';

export default async function postOverrideLimit(serviceId) {
    return axios
        .post(`/AppAuth/Microsoft/${serviceId}/OverrideLimit`, null)
        .then((res) => res)
        .catch((e) => e);
}
